import store from "../store/index"
import { axiosApi, uploadApi } from "./api"
import { dayEnd, dayStart, yearStart, yearEnd, monthStart, monthEnd } from '../util/DateUtil'
import Axios from "axios"

/**
 * API 列表
 * @type {function(*=): *}
 */

// 获取所有区域
export const GET_AREAS = function () {
    return axiosApi("get", "/area/project/all")({
        projectId: store.getters.projectId
    })
}

// 获取区域所有的回路 包含主回路
export const GET_AREA_LOOPS = function (areaId) {
    return axiosApi("get", "/loop/area/all/details")({
        areaId
    })
}

// 获取逆变器日发电量
export const dailyInverter = function (data) {
    let {
        date,
        loopId
    } = data
    let start = dayStart(date)
    let end = dayEnd(date)
    return axiosApi("get", "/diagram/historyCurve/dailyPower/inverter/loop")({
        start,
        end,
        loopId
    })
}

// 回路图表数据  按天获取
export const LOOP_DIAGRAM_DATA_BY_DAY = function (loopId, node, date, source) {
    let start = dayStart(date)
    let end = dayEnd(date)
    return LOOP_DIAGRAM_DATA(loopId, node, start, end, 'h', source)
}


// 回路图表数据  按月获取
export const LOOP_DIAGRAM_DATA_BY_MONTH = function (loopId, node, date, source) {
    let start = monthStart(date)
    let end = monthEnd(date)
    return LOOP_DIAGRAM_DATA(loopId, node, start, end, 'd', source)
}

// 回路图表数据  按年获取
export const LOOP_DIAGRAM_DATA_BY_YEAR = function (loopId, node, date, source) {
    let start = yearStart(date)
    let end = yearEnd(date)
    return LOOP_DIAGRAM_DATA(loopId, node, start, end, 'm', source)
}


export const EXTREMUM_VALUES = (ids, nodes, type, start, end) => {
    return axiosApi("get", "/extremum/values")({
        ids: ids.join(","),
        nodes: nodes.join(","),
        type,
        start,
        end
    })
}

// 获取回路数据
const LOOP_DIAGRAM_DATA = function (loopId, node, start, end, type, source) {
    if (type === 'h') {
        node += '_1h'
    }
    if (type === 'd') {
        node += '_1d'
    }
    if (type === 'm') {
        node += '_1m'
    }

    return axiosApi("get", "/diagram/loop/historycurve", false, source ? source.token : Axios.CancelToken.source().token)({
        deviceLoopId: loopId,
        node,
        start,
        end
    })
}


// 原始influxdb 数据
export const INFLUX_QUERY = (ids, start, end, group, nodes) => {

    return axiosApi("post", "/diagram/influxdb/data", true)({
        "deviceLoopIdList": ids,
        start,
        end,
        group,
        "nodes": nodes,
        // "nodes": [
        // 	"PA_total"
        // ],
        projectId: store.getters.projectId
    })
}


// 能源分析数据
export const POWER_ANALYSIS_BY_LOOP = (d, range, loopId) => {
    let start
    let end
    if (range === 'year') {
        start = yearStart(d)
        end = yearEnd(d)
    } else {
        start = monthStart(d)
        end = monthEnd(d)
    }

    return axiosApi("get", "/power/powerAnalysis/loop")({
        deviceLoopId: loopId,
        start,
        end
    })
}

//变压器
export function transformerList(aid) {
    return axiosApi("get", "/device/transformer/list")({ areaId: aid })
}

// 获取回路图表数据
export function getLoadCharts(data) {
	return axiosApi("get",'/diagram/loop/nodes')(data)
}

// 获取水电气价格
export function getTypePrice() {
	return axiosApi("post",'/v3/cost/EnergyConsumptionCost')({
        projectId:store.getters.projectId
    })
}

// 逆变器总发电 和日发电
export function getPowerloopMax(data) {
	return axiosApi("get",'/power/loop/last/val')(data)
}


// 获取昌华没有建筑分层的回路桑基图
export function getMulberryDistribute(data) {
	return axiosApi("get",'/v3/consume/mulberryDistribute')(data)
                           
}

// 项目分项桑基图
export function getMulberryItemDistribute(data) {
	return axiosApi("get",'/v3/consume/mulberryItemDistribute')(data)
                           
}

// 获取项目逆变器
export function getInverters(data) {
	return axiosApi("get",'/device/inverter')(data)
}

// 获取变压器负载最大值，最小值，均值
export const getTransformerWorkload = function (data) {
	return axiosApi("get",'/diagram/influxdb/data/workload')(data)
}

export function breakerList(aid) {
    return axiosApi("get", "/loop/breaker/list")({ areaId: aid })
}

// 所有回路
export function harmonicAnalysis(projectId) {
    return axiosApi("get", "/loop/all", true)({
        projectId: projectId
    })
}

//逆变器
export function InverterArea(areaId) {
    return axiosApi("get", "/loop/inverter/area", true)({
        areaId
    })
}


//发电量报表
export function InverterLoop(obj) {
    return axiosApi("get", "/diagram/historyCurve/Power/inverter/loop")(obj)
}


//分项能耗对比
export function BuildingItemEnergy(data) {
    return axiosApi("get", "/power/building/itemEnergyConsumption", true)(data)
}

//分类能耗曲线  楼层
export function classifiedEnergyConsumption(data) {
    return axiosApi("get", "/diagram/classifiedEnergyConsumption", true)(data)
}

// 楼栋
export const treeBuilding = () => axiosApi('get', '/building/treeBuilding')({projectId: store.getters.projectId})


//分类能耗占比（项目）
export function ProjectConsumption(data) {
    return axiosApi("get", "/power/project/classifiedEnergyConsumption")(data)
}


//分项能耗（项目）
export function ProjectItemEnergy(data) {
    return axiosApi("get", "/power/project/itemEnergyConsumption")(data)
}
// 通过区域ID获取电容补偿柜
export function LowFeedDevice(id) {
    return axiosApi("get", "/device/capacitorCompensation/details", true)({
        areaId: id
    })
}

// 配电看板
export function distributeDashboard(data) {
    return axiosApi("get", "/v3/distribute/dashboard")(data)
}

// 园区看板
export function getOverviewDashboard() {
    return axiosApi("get", "/v3/overview/dashboard")({
        projectId: store.getters.projectId
    })
}

// 用电发电图表
export function getOverviewReport(data) {
    return axiosApi("get", "/v3/overview/report")(data)
}

// 能耗堆叠图分项数据
export function getitemEnergyConsumption(data) {
    return axiosApi("get", "/diagram/itemEnergyConsumption/project")(data)
}

// 项目变压器总容量
export function getProjectcapacity() {
    return axiosApi("get", "/device/transformer/capacity/project")({
        projectId: store.getters.projectId
    })
}

// 能耗桑基图
export function getConsumeMulberry(data) {
    return axiosApi("get", "/v3/consume/mulberry")(data)
}


// 获取运营成本构成
export function getOperationEnergy(data) {
    return axiosApi("get", "/v3/cost/operationEnergy")(data)
}

// 修改电价
export function editPrice(data) {
    return axiosApi("post", "/v3/cost/electricPrice")(data)
}

// 修改结算日
export function settlementDate(data) {
    return axiosApi("post", "/v3/cost/settlementDate")({
        ...data,
        userId: store.state.homeitem.user.uid
    })
}

// 项目总用电
export function getProjectPowerTotal(data) {
    return axiosApi("get", "/power/total")(data)
}

// 项目总用电无进线 
export function getProjectPowerTotalOut(data) {
    return axiosApi("get", "/power/total/out")(data)
}

// 获取区域总进线
export function getAreaCabLine(data) {
    return axiosApi("get", "/loop/in/area")(data)
}

// 获取区域电容补偿柜
export function getAreaCapacitor(data) {
    return axiosApi("get", "/device/capacitorCompensation/details")(data)
}

// 区域变压器负载 图表
export function getAreaLoadCurve(data) {
    return axiosApi("get", "/v3/distribute/loadCurve")(data)
}

// 项目光伏总容量 通过变流器拿 
export function getPvcapacity() {
    return axiosApi("get", "/device/project/class")({
        projectId: store.getters.projectId,
        classId:11
    })
}

// 项目分类能耗
export function getProjectTypeEnergy(data) {
    return axiosApi("get", "/power/project/classifiedEnergyConsumption")(data)
}

// 项目分项能耗
export function getProjectItemEnergy(data) {
    return axiosApi("get", "/power/project/itemEnergyConsumption")(data)
}

// 测试5分钟数据（配电页面）
export function getWorkloadTotalLine(data) {
    return axiosApi("get", "/v3/distribute/workloadTotalLine")(data)
}

// 获取逆变器MPTT
export function getInverterSeries(data) {
    return axiosApi("get", "/loop/inverter/series")(data)
}

// 获取逆变器MPTT
export function getInverterMppt(data) {
    return axiosApi("get", "/loop/inverter/mppt")(data)
}

// 项目分类能耗图表
export function getProjecTypeEnergyConsumption(data) {
    return axiosApi("get", "/diagram/classifiedEnergyConsumptionOfProject")(data)
}

// 项目分类折标煤图表 
export function getProjecConvertedStandardCoal(data) {
    return axiosApi("get", "/diagram/classifiedEnergyConsumptionOfProject/convertedStandardCoal")(data)
}

// 查询区域的接线图
export function getAreaWiring(data) {
    return axiosApi("get", "/v3/photovoltaic/wiringByAreaId")(data)
}

// 获取缴费账单实时
export function getcurrentBill(data) {
    // return axiosApi("get", "/v3/cost/currentBill")(data)
    return axiosApi("get", "/v3/cost/currentBillBySettlementDate")(data)
}

// 获取缴费账单实时
export function gethistoryBill(data) {
    // return axiosApi("get", "/v3/cost/historyBill")(data)
    return axiosApi("get", "/v3/cost/historyBillBySettlementDate")(data)
}

// 回路id查询回路  获取变压器的高低压回路
export function getLoopDetails(data) {
    return axiosApi("post",'/loop/details')(data)
}


//获取项目的接线图
export function getProjectwirings() {
    return axiosApi("get", "/diagram/wiring/tree")({
        projectId:store.getters.projectId,
    })
}

//计划与实际能耗
//能耗分析
export function planAndReality(data) {
    return axiosApi("get", "/power/building/planAndReality")(data)
}

//节能计划查询
export function conservationPlan(data) {
    return axiosApi("post", "/conservationPlan/list")(data)
}
//计划批量存储
export function listSaveOrUpdate(data) {
    return axiosApi("post", "/conservationPlan/listSaveOrUpdate",true)(data)
}


//能耗分析 新
export function ConsumeAnalyse(data) {
    return axiosApi("get", "/v3/workbench/consumeAnalyse",true)(data)
}

//能耗分析 - 曲线
export function Evaluate(data) {
    return axiosApi("get", "/v3/workbench/evaluate",true)(data)
}


//近七日发电统计
export function DailyPower(obj) {
    return axiosApi("get", "/diagram/historyCurve/dailyPower/inverter")(obj)
}

//发电趋势
export function GenerateTrend(areaId) {
    return axiosApi("get", "/v3/photovoltaic/generateTrend")({areaId})
}

//事件统计
export function EventCount(data) {
    return axiosApi("get", "/v3/overview/event/count")(data)
}

//事件管理-分页查询
export function EventListPage(data) {
    return axiosApi("get", "/v3/overview/event/list/page")(data)
}

//查询所有项目分组
export function userAllgroup(uid) {
    return axiosApi("get", "/v3/base/user/project/all/group")({uid:uid})
}

//查询所有网关
export function DeviceALL() {
    return axiosApi("get", "/device/project/all")({projectId:store.getters.projectId})
}
// 最新报警
export const GetAccidentTimeline = (params) => axiosApi('get', '/alarm/details/type')(params);

//全部标记为已读
export const SetAllRead = (id) => axiosApi('get', '/alarm/all/read')({projectId: id});

//查询所有光伏站点
export const AreaAll = (data) => axiosApi('get', '/v3/base/area/all')(data);

//查询光伏组串图
export const wiringByArea = (data) => axiosApi('get', '/v3/photovoltaic/wiringByAreaId')(data);

//光伏年发电量
export const generateYear = () => axiosApi('get', '/v3/photovoltaic/generateYear')({areaId:store.getters.areaId});


// 通过区域id获取区域的所有安防设备
export const GetSecurityDevices = function () {
	return axiosApi("get", "/device/security/all")({
		projectId:store.getters.projectId
	})
}


// PLC开关控制
export const clist = function () {
	return axiosApi("get", "/ch/clist")({
		projectId:store.getters.projectId
	})
}

// PLC开关控制 开关
export const ctrl = function (data) {
	return axiosApi("post", "/ch/ctrl")(data)
}

//新增分组
export const ctrlAdd = (data) => axiosApi('post', '/ch/ctrl/group/add')(data);

//查询分组
export const ctrlGroupList = (data) => axiosApi('get', '/ch/ctrl/group/list')(data);

//修改分组
export const ctrlGroupUpdate = (data) => axiosApi('post', '/ch/ctrl/group/update')(data);

//删除分组
export const ctrlGroupDelete = (data) => axiosApi('post', '/ch/ctrl/group/delete')(data);

//设备从组中移除
export const ctrlDeviceDel= (data) => axiosApi('post', '/ch/ctrl/group/device/delete')(data);

//查询单个组
export const groupIdList= (groupId) => axiosApi('get', '/ch/ctrl/group/'+groupId)();

//查询单个组
export const deviceAll= (data) => axiosApi('get', '/device/project/category/all')(data);

//首页能耗同环比（项目 kwh）
export function ProjectCompareClassifiedPower(data) {
    return axiosApi("get", "/power/project/compareClassifiedPower", true)(data)
}

//同环比分析（折标煤）
export function CompareClassifiedPower(data,source) {
    return axiosApi("get", "/power/building/compareClassifiedPower", true,source ? source.token : Axios.CancelToken.source().token)(data)
}

//分类能耗占比（楼栋）
export function BuildingConsumption(data) {
    return axiosApi("get", "/power/building/classifiedEnergyConsumption")(data)
}

//今日能耗趋势 （折标煤）
export function convertedStandardCoal(data) {
    return axiosApi("get", "/diagram/classifiedEnergyConsumptionOfProject/convertedStandardCoal", true)(data)
}

// 通过项目ID获取项目信息
export const GetProJectInfo = function () {
	return axiosApi("get", "/project/info")({
		projectId: store.getters.projectId
	})
}

// 通过项目ID获取项目信息
export const loopList = function (data) {
	return axiosApi("get", "/v3/workbench/loopList")(data)
}
//查询设备信息
export const GetWireByDeviceID = (deviceId) => axiosApi('get', '/device/details')({deviceId: deviceId});

// 所有EBOX和监控设备
export const GetEboxAndMonitor = function () {
	return axiosApi("get", "/device/security/ebox/all/project")({
		projectId:store.getters.projectId
	})
}

// 通过区域id获取区域的传感器
export const GetSensor = function (areaId) {
	return axiosApi("get", "/loop/sensor")({
		areaId,
	})
}

// 开关控制
export const appControl = function () {
	return axiosApi("get", "/loop/appControl")({
		projectId:store.getters.projectId
	})
}
// 开关控制
export const loopCtrl = function (data) {
	return axiosApi("get", "/loop/ctrl")(data)
}

// 添加或修改节能计划
export const saveOrUpdate = function (data) {
	return axiosApi("post", "/conservationPlan/saveOrUpdate")(data)
}

// 项目建筑节能计划
export const conservationPlanSingle = function (data) {
	return axiosApi("post", "/conservationPlan/single")(data)
}


// 节能计划  计划与实际
export const projectConservationPlan = function (data) {
	return axiosApi("post", "/conservationPlan/project")(data)
}
// 回路列表
export const loopTreeList = function () {
	return axiosApi("get", "/v3/workbench/loopTreeList")({
		projectId:store.getters.projectId
	})
}

// 光伏概况
export const generateOverview = function () {
	return axiosApi("get", "/v3/photovoltaic/generateOverview")({
		projectId:store.getters.projectId
	})
}

// 分类能耗查询(区域)
export const classifiedEnergyConsumptionOfArea = function (data) {
	return axiosApi("get", "/diagram/classifiedEnergyConsumptionOfArea")(data)
}


// 光伏发电量 按照id查询
export const photovoltaicReport = function (data) {
	return axiosApi("get", "/v3/photovoltaic/report")(data)
}

// 光伏发电功率
export const inverterTotalLine = function (data) {
	return axiosApi("get", "/v3/photovoltaic/inverterTotalLine/area")(data)
}

// 获取低压进线柜的总有功功率
export const loopMaster = function (data) {
	return axiosApi("get", "/loop/master")(data)
}

// 光设备台账
export const deviceAccount = function () {
	return axiosApi("get", "/v3/workbench/deviceAccount")({
		projectId:store.getters.projectId
	})
}

// UPS
export const deviceUps = function () {
	return axiosApi("get", "/device/upsTree")({
		projectId:store.getters.projectId
	})
}

// 用户信息
export const userInfo = function (data) {
	return axiosApi("get", "/user/info")(data)
}

// 获取项目的所有摄像头
export const _getProjectCamera=(data)=>{
	return axiosApi("get",'/device/camera/project')(data)
}

// 获取摄像头的视频流地址 
export const _getCameraPlayAddress=(data)=>{
	return axiosApi("get",'/ezviz/playAddress')(data)
}

// 能耗分析查电水热冷（不是折标煤 
export const compareClassifiedPower=(data)=>{
	return axiosApi("get",'/v3/workbench/project/compareClassifiedPower')(data)
}


// 远程抄表 - 获取模板列表
export const _getMeterTemplate=(data)=>{
	return axiosApi("get",'/v3/workbench/deviceMeterReading')(data)
}

// 远程抄表 - 获取模板表格数据
export const _getMeterTemplateData=(data)=>{
	return axiosApi("post",'/v3/workbench/MeterReadingReport')(data)
}

// 远程抄表 - 模板绑定表头
export const _setTemplateHeader=(data)=>{
	return axiosApi("post",'/v3/workbench/bindMeterReadingTemplateHeader')(data)
}

// 远程抄表 - 模板绑定电表
export const _setTemplateMeter=(data)=>{
	return axiosApi("post",'/v3/workbench/bindMeterReadingTemplateDeviceLoop')(data)
}

// 远程抄表 - 新建模板
export const _addTemplate=(data)=>{
	return axiosApi("post",'/v3/workbench/addMeterReadingTemplate')(data)
}

// 远程抄表 - 删除模板
export const _removeTemplate=(data)=>{
	return axiosApi("post",'/v3/workbench/deleteMeterReadingTemplate')(data)
}
export  function alarmCheck(ids) {
	return axiosApi("put", "/alarm/check",true)(ids)
}

//能耗分析
export  function consumerAnalysisItemLoopTree() {
	return axiosApi("get", "/v3/workbench/consumerAnalysisItemLoopTree")({projectId:store.getters.projectId})
}

//获取所有设备类别
export  function categoryAll() {
	return axiosApi("get", "/device/category/all")()
}

//获取所有设备类型
export  function DeviceTypeAll(data) {
	return axiosApi("get", "/device/type/all")(data)
}

//获取所有设备品牌
export  function DeviceBrandAll() {
	return axiosApi("get", "/device/brand/all")()
}

//获取所有设备型号
export  function DeviceModelAll() {
	return axiosApi("get", "/device/model/all")()
}

//修改设备名称
export  function DeviceUpdate(data) {
	return axiosApi("put", "/device/update")(data)
}

//添加设备
export  function DeviceAdd(data) {
	return axiosApi("post", "/device/add")(data)
}

//删除设备
export  function DeviceDelete(data) {
	return axiosApi("delete", "/device/delete")(data)
}


//获取数据字典
export  function getLookup(data) {
	return axiosApi("get", "/common/lookup")(data)
}



//删除回路及子回路
export  function delCascade(data) {
	return axiosApi("delete", "/loop/delCascade")(data)
}
//修改回路
export  function loopUpdate(data) {
	return axiosApi("put", "/loop/update")(data)
}
//添加回路
export  function loopAdd(data) {
	return axiosApi("post", "/loop/add")(data)
}
//添加回路
export  function breakList(data) {
	return axiosApi("get", "/loop/break/list")(data)
}

//回路排序
export  function updateSort(data) {
	return axiosApi("put", "/loop/updateSort",true)(data)
}

//事件统计
export const AlarmStatistics = (params) => axiosApi('get', '/alarm/event/statistics', true)(params);

//开关控制定时
export const cronUpdate = (params) => axiosApi('put', '/ch/ctrl/group/cron/update')(params);


//开关控制定时
export const groupCheck = (params) => axiosApi('get', '/ch/ctrl/group/check')(params);

//回路控制
export const loopControl = (params) => axiosApi('get', '/loop/loopControl')({projectId:store.getters.projectId})

//查询报警模板
export const alarmTemplate = (params) => axiosApi('get', '/alarm/template/project')(params)

//查询推送人员设置
export const alarmNotice = (params) => axiosApi('get', '/alarm/template/notice/user')(params)

//查询报警模板详情
export const templateDetail = (params) => axiosApi('get', '/alarm/template/detail')(params)

//查询推送人员
export const templateUser = (params) => axiosApi('get', '/alarm/template/notice/user')(params)

//设置推送人员
export const templatePushUser = (params) => axiosApi('post', '/alarm/template/push/notice/user')(params)

//设置报警模板
export const noticeTypeUpdate = (params) => axiosApi('put', '/alarm/template/noticeType/update')(params)

//能耗分析对比
export const projectLoopEnergy = (params) => axiosApi('get', '/v3/workbench/project/loop/energy')(params)
//传感器类型
export const sensorType = (params) => axiosApi('get', '/loop/sensor/type')(params)

//eym配电概况
export const eymOverview = (params) => axiosApi('get', '/device/area/power/overview')(params)

//eym分项能耗
export const eymitemEnergyConsumption = (params) => axiosApi('get', '/power/area/itemEnergyConsumption')(params)

//eym区域用电量
export const eymAreaReport = (params) => axiosApi('get', '/v3/overview/area/report')(params)

//eym用电排行
export const eymPowerSort = (params) => axiosApi('get', '/power/loops/area/power/sort')(params)


























